import { Guid } from "@syncfusion/ej2/pdf-export";

export class getClientReportBo {
    currentpageno: number=1;
    pageitem: number = 10;
    orderColumn: string = "clientName";;
    orderType: string = "asc";
    field: string = "clientName";
    value: string = "";
    matchCase: boolean;
    operator: string = "contains";
    type: string = "string";
    client: Guid | null;
    statusLid: Guid | null;
    genderLid: Guid | null;
    clientTypeLid: Guid | null;
    // pCATypeLid: number | null;
    // assessmentRatingLid: number | null;
    typeofWaiverLid: Guid | null;
    employeeId: Guid | null;
    locationID: Guid | null;
    agencyID: Guid | null;
}
export class ClientBirthDayReportBo {
    
    fromDate: string;
    endDate: string;
    locationId: Guid;
}






export class gettimesheetBO {
    start: string | null;
    end: string | null;
    employee: Guid | null=0;
    client: Guid | null;
    payor: Guid | null;
    currentpage: number=1;
    pageitems: number=10;
    agencyId: Guid;
    status: any=0;
    orderColumn: string="clientName";
    orderType: string="asc";
    field: string="clientName";
    value: string="";
    matchCase: boolean;
    operator: string="contains";
    type: string="string";
    clientstatus: string="Expired SA";
    locationLid: Guid=0;
    dateFilterType: string;

}
export class reportBO {
    clientName: string;
    clientId: Guid;
    dOB: string;
    email: string;
    phone: string;
    startDate: string | null;
    endDate: string | null;
    insuranceNumber: string;
    companyName: string;
    payorName: string;
    serviceCode: string;
    totalUnits: number | null;
    exceededUnits: number | null;
    usedUnits: number | null;
    remainingUnits: number | null;
    hoursPerDay: number | null;
    remainingHours: number | null;
    id: Guid;
    agencyId: Guid;
    firstName: string;
    lastName: string;
    middleName: string;
    qPname: string;
    genderLid: Guid;
    age: number | null;
    weight: number | null;
    aKA: string;
    medicaid: string;
    medicare: string;
    street: string;
    apt: string;
    phone1: string;
    phone2: string;
    county: string;
    state: string;
    city: string;
    zipCode: string;
    sSN: string;
    statusLid: Guid;
    status_Name: string;
    userName: string;
    password: string;
    locationStatusLid: Guid | null;
    name: string;
    requiredEVV: boolean | null;
    loginUserId: string | null;
    tempClientId: Guid | null;
    locationName: string;
    gender_Name: string;
    responsiblePartyPhone: string;
    responsiblePartyEmail: string;
    totalhrsparDay: number | null;
    totalhrsperWeek: number | null;
    remaininghrsparDay: number | null;
    remaininghrsperWeek: number | null;
    previouslyUsedUnit: number | null;
}
export class returnclientReportBo {
    clientReport: reportBO[];
    totalCount: number;
}
